import { render, staticRenderFns } from "./DeviceRevenue.vue?vue&type=template&id=4605218a"
import script from "./DeviceRevenue.vue?vue&type=script&lang=js"
export * from "./DeviceRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports